import Const from "@/api/const";

const SCRIPT_ID = "yandex-metrika";

function ensureCommandQueue() {
  if (window.ym) return;

  window.ym = function () {
    window.ym.a = window.ym.a || [];
    window.ym.a.push(arguments);
  };
  window.ym.l = Date.now();
}

function loadScript() {
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = "https://mc.yandex.ru/metrika/tag.js";
  document.head.appendChild(script);
}

function scheduleScriptLoading() {
  const schedule = () => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadScript, { timeout: 3000 });
    } else {
      window.setTimeout(loadScript, 1500);
    }
  };

  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
}

export function initYandexMetrika() {
  ensureCommandQueue();

  window.ym(Const.YM_ID, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    ecommerce: "dataLayer",
  });

  scheduleScriptLoading();
}
